
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Arches Icons","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 577.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#e0dbc8"}},[_c('path',{attrs:{"data-name":"Arch TR","d":"M947.83 169.34A52.23 52.23 0 01902 142.17a72.43 72.43 0 00-127.18 0 52.21 52.21 0 01-91.61-50.1 176.85 176.85 0 01310.41 0 52.24 52.24 0 01-45.76 77.27z"}}),_c('path',{attrs:{"data-name":"Arch MR","d":"M947.83 373.48A52.21 52.21 0 01902 346.31a72.43 72.43 0 00-127.18 0 52.21 52.21 0 11-91.61-50.1 176.85 176.85 0 01310.41 0 52.23 52.23 0 01-45.76 77.27z"}}),_c('path',{attrs:{"data-name":"Arch BR","d":"M947.83 577.62A52.21 52.21 0 01902 550.45a72.43 72.43 0 00-127.18 0 52.21 52.21 0 11-91.61-50.1 176.85 176.85 0 01310.41 0 52.23 52.23 0 01-45.76 77.27z"}}),_c('path',{attrs:{"data-name":"Arch MM","d":"M609.44 373.48a52.19 52.19 0 01-45.85-27.17 72.43 72.43 0 00-127.18 0 52.212 52.212 0 01-91.62-50.1 176.85 176.85 0 01310.41 0 52.22 52.22 0 01-45.76 77.27z"}}),_c('path',{attrs:{"data-name":"Arch BM","d":"M609.44 577.62a52.19 52.19 0 01-45.85-27.17 72.43 72.43 0 00-127.18 0 52.212 52.212 0 01-91.62-50.1 176.85 176.85 0 01310.41 0 52.22 52.22 0 01-45.76 77.27z"}}),_c('path',{attrs:{"data-name":"Arch BL","d":"M271.06 577.62a52.21 52.21 0 01-45.86-27.17 72.43 72.43 0 00-127.17 0 52.212 52.212 0 01-91.62-50.1 176.85 176.85 0 01310.41 0 52.23 52.23 0 01-45.76 77.27z"}})])])
          )
        }
      }
    